/* global process */
let finBase = window._env_.VUE_APP_FIN_CENTER_HOST

export const getPaymentRefundTable = params => {
  return axios.post(`${finBase}/payment-refund/lists`, params)
}
export const getPaymentRefundDetail = params => {
  return axios.get(`${finBase}/payment-refund/${params.id}`, {params})
}
export const exportPaymentRefundTableData = params => {
  return axios.post(`${finBase}/payment-refund/export/lists`, params)
}
export const exportPaymentRefundDetailData = params => {
  return axios.post(`${finBase}/payment-refund/export/detail`, params)
}
export const downloadRefundPdfFile = params => {
  return `${finBase}/payment-refund/${params.id}/pdf`
}
export const downloadRefundPdfsFiles = params => {
  return axios.post(`${finBase}/payment-refund/batch/pdfs`, params)
}
export const downloadPdfFileFromServer = params => {
  return `${finBase}/download_pdf?file=${params.filename}`
}

export const exportPaymentRefundSummaryData = params => {
  return axios.post(`${finBase}/payment-refund/summary`, params)
}



// WEBPACK FOOTER //
// ./src/views/payment-refund/payment-refund.api.js